import React from 'react';
import { path } from 'ramda';

import { useTheme } from '../../../common/styling/theme';

import { ReactComponent as OuigoLogo } from '../../../common/assets/images/ouigo-logo.svg';

const Logo: React.FC = () => {
  const { theme } = useTheme();

  return <OuigoLogo color={path(['colors', 'secondary', 'main'], theme)} width="100%" height="100%" />;
};

export default Logo;
